module.exports = __webpack_public_path__ + "media/ai-meme.273ae164.mp4";